import { useMemo } from 'react';
import { useAuthStore } from '../../store/authStore';
import { useEscolaComunicados } from '../../api/hooks/useEscolaComunicados';
import { ComunicadosStatsCore } from '../../components/comunicados/ComunicadosStatsCore';
import type { ComunicadoItem, ComunicadoStats } from '../../components/comunicados/ComunicadosConfig';

export default function ComunicadosStatsEscola() {
  const { escolaId, user } = useAuthStore();
  const { data: comunicados = [], stats, isLoading } = useEscolaComunicados();

  const config = useMemo(
    () => ({
      scope: 'ESCOLA' as const,
      scopeId: escolaId || '',
      branding: {
        tenantName: (user as any)?.escolaNome || 'Escola Municipal',
        tenantBadge: 'Direção & Coordenação Escolar',
        logoUrl: (user as any)?.escolaLogoUrl,
        primaryColor: '#2563eb',
        secondaryColor: '#1d4ed8',
        slogan: 'Educação para o Futuro',
        autoridadeNome: user?.nome,
        autoridadeCargo: 'Direção Escolar',
      },
    }),
    [escolaId, user]
  );

  return (
    <ComunicadosStatsCore
      config={config}
      comunicados={comunicados as unknown as ComunicadoItem[]}
      stats={stats as unknown as ComunicadoStats}
      isLoading={isLoading}
    />
  );
}
